import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError, tap, of, first, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private toastService: ToastService, private http: HttpClient, private router: Router) { }

  isUpload: any = false;
  isUploadChanges: Subject<any> = new Subject<any>();

  isLogged: any = false;
  isLoggedChanges: Subject<any> = new Subject<any>();


  stepLogin: any = false;
  stepLoginChanges: Subject<any> = new Subject<any>();


  registerGhost(uuid: string) {

    const body = { uuid: uuid };

    return this.http
      .post(`${environment.apiUrl}/auth/ghost/register`, body) // Utilisation de la méthode POST
      .pipe(
        map((res: any) => {
          this.isLogged = true;
          this.isLoggedChanges.next(this.isLogged);
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  login(email: string, password: string) {
    const body = { email: email, password: password };

    return this.http
      .post(`${environment.apiUrl}/auth/login`, body) // Utilisation de la méthode POST
      .pipe(
        map((res: any) => {

          if (res !== 'Wrong password') {
            this.isLogged = true;
            this.isLoggedChanges.next(this.isLogged);
          }

          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  loginWithGoogle(user: any, UUID: string) {

    let username;
    if (user.additionalUserInfo.profile.given_name && user.additionalUserInfo.profile.family_name) {
      username = user.additionalUserInfo.profile.given_name + '_' + user.additionalUserInfo.profile.family_name.charAt(0);
    } else {
      username = user.additionalUserInfo.profile.given_name
    }

    const body = {
      // idToken: user.credential.idToken,
      idToken: user.user._delegate.accessToken,
      email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : '',
      firstname: user.additionalUserInfo.profile.given_name ? user.additionalUserInfo.profile.given_name : '',
      name: user.additionalUserInfo.profile.family_name ? user.additionalUserInfo.profile.family_name : '',
      username: username,
      uuid: UUID
    };

    const url = environment.apiUrl.replace('/app', '');

    return this.http
      .post(`${url}/auth/google`, body) // Utilisation de la méthode POST
      .pipe(
        map((res: any) => {
          this.isLogged = true;
          this.isLoggedChanges.next(this.isLogged);
          return res;
        }),
        catchError((error: any) => {
          if (error.error.message == 'The email has already been taken.') {
            this.toastService.presentToast('Cet email est déjà utilisé', 2000, 'danger', 'alert-circle');
          }
          this.checkIfTokenExpired(error);
          throw new Error(error);
        })
      );
  }

  convertToClassicUser(email: string, password: string, firstname: string, lastname: string) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    
    const body = { email: email, password: password, firstname: firstname, name: lastname, username: firstname + lastname };

    return this.http
      .put(`${environment.apiUrl}/user/convert`, body, {
        headers: headers
      }) // Utilisation de la méthode POST
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  currentUser: any;
  currentUserChanges: Subject<any> = new Subject<any>();

  getUserMe() {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .get(`${environment.apiUrl}/users/me`, { headers }) // Utilisation de la méthode GET
      .pipe(
        map((res: any) => {

          this.currentUser = res.user;
          this.currentUserChanges.next(this.currentUser);
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  documentAdd(file: any, user: any, fileTitle: string, selectedFileType: any, selectedCompanyForUpload: any) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    const formData = new FormData();

    formData.append('title', fileTitle);
    formData.append('name', file.name);
    formData.append('type', file.type);
    formData.append('weight', file.size);
    formData.append('user_id', user.id);
    formData.append('file', file);
    if (selectedFileType) {
      formData.append('prompt_id', selectedFileType.id);
    }
    formData.append('company_id', selectedCompanyForUpload.id);


    return this.http.post(`${environment.apiUrl}/documents/add`, formData, {
      reportProgress: true,
      observe: 'events',
      headers: headers
    }).pipe(
      catchError((error) => {
        this.checkIfTokenExpired(error);
        return error;
      }),
      tap((data: any) => { }),
      map((data: any) => {
        return data;
      })
    );
  }

  getDocument(document_id: string) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .get(`${environment.apiUrl}/documents/${document_id}`, { headers }) // Utilisation de la méthode GET
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  getDocumentContent(document_id: string) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .get(`${environment.apiUrl}/documents/${document_id}/content`, { headers }) // Utilisation de la méthode GET
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  // SEARCH
  searchInformation(search: string, conversation: any[], company_id: string, conversationId: number | null, documentsIds: any, taxonomiesIds: any, instructionId: any, file_type: any) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .post(`${environment.apiUrl}/search/information`, {
        search: search,
        company_id: company_id,
        conversation: conversation,
        rag_answer_id: conversationId,
        document_ids: documentsIds || [],
        taxonomy_ids: taxonomiesIds || [],
        instruction_id: instructionId || [],
        timecode: file_type >= 5 ? true : false
      }, { headers })
      .pipe(
        catchError((error) => {
          this.checkIfTokenExpired(error);
          return error;
        }),
        tap((data: any) => { }),
        map((data: any) => {
          return data;
        })
      );
  }

  getAppPrompts() {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .get(`${environment.apiUrl}/prompts`, { headers }) // Utilisation de la méthode GET
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  deleteAccount(id: any) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return this.http
      .delete(`${environment.apiUrl}/user/${id}`, { headers }) // Utilisation de la méthode GET
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          this.checkIfTokenExpired(error);
          throw new Error(error.message);
        })
      );
  }

  checkIfTokenExpired(error: any) {
    if (error.status === 401 && error.error.error === 'Expired token') {
      localStorage.removeItem('token');
      // window.location.reload();
      // this.router.navigate(['/home']);
    } else if (error.status === 422 && error.error.message === 'The email field must be a valid email address.') {
      this.toastService.presentToast('Identifiant incorrect', 2000, 'danger', 'alert-circle');
    }
  }

  get(url: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}` // Exemple d'ajout de token
    });
  
    return this.http.get(url, { headers });
  }
}


